var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPurpleRibbonSelectDiscount = function SvgPurpleRibbonSelectDiscount(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "49px",
    viewBox: "0 0 36 49",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 12")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Policy-detalis-3-options-desk-open",
    transform: "translate(-960.000000, -401.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(960.000000, 401.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75,-3.63931107e-13 L32.45,-3.63931107e-13 C33.9687831,-3.68256954e-13 35.2,1.23121694 35.2,2.75 L35.2,3.3 L35.2,3.3 L3.62376795e-13,3.3 L3.62376795e-13,2.75 C3.62190798e-13,1.23121694 1.23121694,-3.63652112e-13 2.75,-3.63931107e-13 Z",
    id: "Rectangle",
    fill: "#302369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3,-1.84741111e-13 L31.9,-1.84741111e-13 L31.9,45.9549412 C31.9,46.5624544 31.4075132,47.0549412 30.8,47.0549412 C30.5311121,47.0549412 30.2715365,46.9564536 30.0703234,46.7780888 L18.3296766,36.3706291 C17.913254,36.0014926 17.286746,36.0014926 16.8703234,36.3706291 L5.12967664,46.7780888 C4.67506477,47.1810781 3.97984167,47.1392297 3.57685238,46.6846179 C3.39848763,46.4834047 3.3,46.2238291 3.3,45.9549412 L3.3,-1.84741111e-13 L3.3,-1.84741111e-13 Z",
    id: "Rectangle",
    fill: "#5743AF"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPurpleRibbonSelectDiscount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/purple_ribbon_select_discount.951a4b30.svg";
export { ForwardRef as ReactComponent };